import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import ReduxThunk from "redux-thunk";
import modules from "./modules";

const configure = () => {
    const store = createStore(
        modules,
        composeWithDevTools(applyMiddleware(ReduxThunk))
    );

    return store;
};

export default configure;
